// extracted by mini-css-extract-plugin
export default {"backgroundHeader":"G6f0eee"};